import React from 'react'
import { com } from '@eidu/web'
import { DatePicker, Loader, TextInput } from '@common/ui'
import DraftFieldValue from '../../domain/entity/DraftFieldValue'
import Field = com.eidu.entity.field.Field

export type EntityFormDateFieldProps = {
  field: Field
  fieldValue: DraftFieldValue | undefined
  updateField?: (value: DraftFieldValue) => void
  error: boolean
  loading?: boolean
  disabled?: boolean
  dropdownWithinPortal?: boolean
}

const EntityFormDateField = ({
  field,
  fieldValue,
  updateField,
  error,
  loading = false,
  disabled = false,
  dropdownWithinPortal = true,
}: EntityFormDateFieldProps) => (
  <div>
    {loading ? (
      <TextInput
        key={`field-${field.id.toString()}`}
        required={field.required}
        label={field.name}
        value={fieldValue?.value ?? ''}
        disabled
        placeholder=" "
        rightSection={<Loader size="xs" />}
      />
    ) : (
      <DatePicker
        key={`field-${field.id.toString()}`}
        disabled={disabled || !updateField}
        required={field.required}
        label={field.name}
        value={fieldValue?.value || null}
        onChange={(pickerValue) => {
          updateField?.({ fieldId: field.id, type: field.type, value: pickerValue ?? '' })
        }}
        error={error}
        popoverProps={{ withinPortal: dropdownWithinPortal }}
      />
    )}
  </div>
)

export default EntityFormDateField
